/**
 * 公告相关API
 */
import axiosInstance from '../services/axiosConfig';
import { API_PATHS } from './config';
import Logger from '../utils/logger';

/**
 * 获取所有启用的公告
 * @returns {Promise<{success: boolean, message: string, data: Array}>}
 */
export async function getActiveAnnouncements() {
  try {
    const response = await axiosInstance.get(
      `${API_PATHS.BASE_API_URL}/announcement/public/active`
    );
    return response;
  } catch (error) {
    Logger.error('获取公告失败', error);
    return {
      success: false,
      message: error.message || '获取公告失败',
      data: []
    };
  }
}

/**
 * 获取需要弹窗显示的公告
 * @returns {Promise<{success: boolean, message: string, data: Array}>}
 */
export async function getPopupAnnouncements() {
  try {
    const response = await axiosInstance.get(
      `${API_PATHS.BASE_API_URL}/announcement/public/popup`
    );
    return response;
  } catch (error) {
    Logger.error('获取弹窗公告失败', error);
    return {
      success: false,
      message: error.message || '获取弹窗公告失败',
      data: []
    };
  }
}

/**
 * 检查是否需要显示公告弹窗
 * 基于localStorage存储的"今日不再提示"标记
 * @returns {boolean}
 */
export function shouldShowAnnouncementPopup() {
  const dismissedDate = localStorage.getItem('announcement_dismissed_date');
  if (!dismissedDate) {
    return true;
  }
  
  const today = new Date().toDateString();
  return dismissedDate !== today;
}

/**
 * 标记今日不再显示公告弹窗
 */
export function dismissAnnouncementForToday() {
  const today = new Date().toDateString();
  localStorage.setItem('announcement_dismissed_date', today);
}

/**
 * 清除公告弹窗标记（用于测试或重置）
 */
export function clearAnnouncementDismiss() {
  localStorage.removeItem('announcement_dismissed_date');
}

export default {
  getActiveAnnouncements,
  getPopupAnnouncements,
  shouldShowAnnouncementPopup,
  dismissAnnouncementForToday,
  clearAnnouncementDismiss
};

